import { render } from "./IconInfo.vue?vue&type=template&id=49e74f5d"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49e74f5d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49e74f5d', __exports__)) {
    api.reload('49e74f5d', __exports__)
  }
  
  module.hot.accept("./IconInfo.vue?vue&type=template&id=49e74f5d", () => {
    api.rerender('49e74f5d', render)
  })

}


export default __exports__